/**
 * Purchase Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Purchase Request Schema
 */
export interface PurchaseRequest { 
    creationDate?: string;
    lastUpdateDate?: string;
    createdBy?: string;
    lastUpdatedBy?: string;
    objectVersionNumber?: number;
    id?: number;
    title?: string;
    series?: string;
    scheduleDate?: string;
    status?: PurchaseRequest.StatusEnum;
    description?: string;
    deleteFlag?: boolean;
}
export namespace PurchaseRequest {
    export const StatusEnum = {
        Pending: 'PENDING',
        Rejected: 'REJECTED',
        Approved: 'APPROVED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


